import React, { useState } from 'react';
import { Search, MapPin, ArrowRight, IndianRupee, Car, Clock, Route } from 'lucide-react';

const CabServices = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('distance');

  const routes = [
    { from: "Delhi", to: "Chandigarh", distance: 250, fareMin: 3000, fareMax: 3500 },
    { from: "Lucknow", to: "Varanasi", distance: 320, fareMin: 3800, fareMax: 4200 },
    { from: "Gurgaon", to: "Hisar", distance: 180, fareMin: 2200, fareMax: 2600 },
    { from: "Amritsar", to: "Ludhiana", distance: 140, fareMin: 1800, fareMax: 2200 },
    { from: "Jaipur", to: "Udaipur", distance: 400, fareMin: 4800, fareMax: 5500 },
    { from: "Bhopal", to: "Indore", distance: 190, fareMin: 2300, fareMax: 2600 },
    { from: "Mumbai", to: "Pune", distance: 150, fareMin: 1800, fareMax: 2200 },
    { from: "Ahmedabad", to: "Surat", distance: 270, fareMin: 3200, fareMax: 3800 },
    { from: "Panjim", to: "Madgaon", distance: 35, fareMin: 700, fareMax: 900 },
    { from: "Patna", to: "Gaya", distance: 110, fareMin: 1400, fareMax: 1700 },
    { from: "Ranchi", to: "Jamshedpur", distance: 130, fareMin: 1700, fareMax: 2000 },
    { from: "Kolkata", to: "Digha", distance: 190, fareMin: 2300, fareMax: 2600 },
    { from: "Bhubaneswar", to: "Puri", distance: 65, fareMin: 1000, fareMax: 1200 },
    { from: "Raipur", to: "Bilaspur", distance: 120, fareMin: 1500, fareMax: 1800 },
    { from: "Hyderabad", to: "Warangal", distance: 150, fareMin: 1900, fareMax: 2200 },
    { from: "Visakhapatnam", to: "Vijayawada", distance: 350, fareMin: 4000, fareMax: 4500 },
    { from: "Chennai", to: "Coimbatore", distance: 510, fareMin: 5500, fareMax: 6200 },
    { from: "Kochi", to: "Thiruvananthapuram", distance: 200, fareMin: 2500, fareMax: 2800 },
    { from: "Bengaluru", to: "Mysuru", distance: 150, fareMin: 1800, fareMax: 2200 },
    { from: "Guwahati", to: "Kaziranga", distance: 200, fareMin: 2400, fareMax: 2800 },
    { from: "Shillong", to: "Cherrapunji", distance: 55, fareMin: 900, fareMax: 1100 },
    { from: "Agartala", to: "Udaipur (Tripura)", distance: 55, fareMin: 900, fareMax: 1100 },
    { from: "Imphal", to: "Moreh", distance: 110, fareMin: 1400, fareMax: 1700 },
    { from: "Aizawl", to: "Lunglei", distance: 160, fareMin: 2000, fareMax: 2400 },
    { from: "Kohima", to: "Dimapur", distance: 75, fareMin: 1200, fareMax: 1500 },
    { from: "Itanagar", to: "Ziro", distance: 110, fareMin: 1400, fareMax: 1800 },
    { from: "Gangtok", to: "Siliguri", distance: 115, fareMin: 1500, fareMax: 1800 },
    { from: "Shimla", to: "Manali", distance: 250, fareMin: 3000, fareMax: 3500 },
    { from: "Dehradun", to: "Rishikesh", distance: 45, fareMin: 800, fareMax: 1000 },
    { from: "Srinagar", to: "Jammu", distance: 250, fareMin: 3000, fareMax: 3500 },
    { from: "Leh", to: "Kargil", distance: 215, fareMin: 2800, fareMax: 3200 },
    { from: "Port Blair", to: "Baratang Island", distance: 100, fareMin: 1400, fareMax: 1700 },
    { from: "Puducherry", to: "Chennai", distance: 160, fareMin: 2000, fareMax: 2400 },
    { from: "Chandigarh", to: "Delhi", distance: 250, fareMin: 3000, fareMax: 3500 },
  ];

  const filteredRoutes = routes.filter(route => 
    route.from.toLowerCase().includes(searchTerm.toLowerCase()) ||
    route.to.toLowerCase().includes(searchTerm.toLowerCase())
  ).sort((a, b) => {
    if (sortBy === 'distance') return a.distance - b.distance;
    if (sortBy === 'fare') return a.fareMin - b.fareMin;
    return 0;
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-yellow-100">
      {/* Header */}
      <div className="bg-yellow-400 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2 sm:mb-3">
            {/* <Car className="w-8 h-8 sm:w-10 sm:h-10 text-black" /> */}
            <h1 className="text-2xl sm:text-4xl md:text-5xl font-black text-black text-center">One Way Cab Services</h1>
          </div>
          <p className="text-center text-black text-sm sm:text-lg font-medium">Comfortable & Affordable Intercity Travel Across India</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        {/* Search and Filter Bar */}
        {/* <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 mb-6 sm:mb-8 border-2 border-yellow-400">
          <div className="flex flex-col gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-yellow-600" />
              <input
                type="text"
                placeholder="Search by city name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full bg-yellow-50 text-black placeholder-gray-600 pl-12 pr-4 py-3 rounded-xl border-2 border-yellow-300 focus:outline-none focus:border-yellow-500 font-medium"
              />
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setSortBy('distance')}
                className={`flex-1 sm:flex-none px-4 sm:px-6 py-3 rounded-xl font-bold transition-all text-sm sm:text-base ${
                  sortBy === 'distance' 
                    ? 'bg-yellow-400 text-black shadow-md' 
                    : 'bg-yellow-100 text-black hover:bg-yellow-200'
                }`}
              >
                Sort by Distance
              </button>
              <button
                onClick={() => setSortBy('fare')}
                className={`flex-1 sm:flex-none px-4 sm:px-6 py-3 rounded-xl font-bold transition-all text-sm sm:text-base ${
                  sortBy === 'fare' 
                    ? 'bg-yellow-400 text-black shadow-md' 
                    : 'bg-yellow-100 text-black hover:bg-yellow-200'
                }`}
              >
                Sort by Fare
              </button>
            </div>
          </div>
        </div> */}

        {/* Stats Cards */}
        {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
          <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md border-l-4 border-yellow-400">
            <div className="flex items-center gap-3 mb-2">
              <Route className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-600" />
              <h3 className="font-bold text-black text-base sm:text-lg">Total Routes</h3>
            </div>
            <p className="text-2xl sm:text-3xl font-black text-yellow-600">{routes.length}</p>
          </div>
          <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md border-l-4 border-yellow-400">
            <div className="flex items-center gap-3 mb-2">
              <MapPin className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-600" />
              <h3 className="font-bold text-black text-base sm:text-lg">Shortest Trip</h3>
            </div>
            <p className="text-2xl sm:text-3xl font-black text-yellow-600">35 km</p>
          </div>
          <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md border-l-4 border-yellow-400">
            <div className="flex items-center gap-3 mb-2">
              <IndianRupee className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-600" />
              <h3 className="font-bold text-black text-base sm:text-lg">Starting From</h3>
            </div>
            <p className="text-2xl sm:text-3xl font-black text-yellow-600">₹700</p>
          </div>
        </div> */}

        {/* Routes Table - Desktop */}
        <div className="hidden md:block bg-white rounded-2xl shadow-lg overflow-hidden border-2 border-yellow-400">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-yellow-400">
                  <th className="px-6 py-4 text-left text-black font-black text-sm uppercase">#</th>
                  <th className="px-6 py-4 text-left text-black font-black text-sm uppercase">From</th>
                  <th className="px-6 py-4 text-center text-black font-black text-sm uppercase"></th>
                  <th className="px-6 py-4 text-left text-black font-black text-sm uppercase">To</th>
                  <th className="px-6 py-4 text-center text-black font-black text-sm uppercase">Distance</th>
                  <th className="px-6 py-4 text-center text-black font-black text-sm uppercase">Duration</th>
                  <th className="px-6 py-4 text-right text-black font-black text-sm uppercase">Fare Range</th>
                </tr>
              </thead>
              <tbody>
                {filteredRoutes.map((route, index) => (
                  <tr 
                    key={index}
                    className="border-b border-yellow-100 hover:bg-yellow-50 transition-colors"
                  >
                    <td className="px-6 py-4 text-black font-bold">{index + 1}</td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <MapPin className="w-4 h-4 text-yellow-600" />
                        <span className="font-bold text-black">{route.from}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <ArrowRight className="w-5 h-5 text-yellow-600 mx-auto" />
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <MapPin className="w-4 h-4 text-yellow-600" />
                        <span className="font-bold text-black">{route.to}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="inline-block bg-yellow-100 text-black px-3 py-1 rounded-full font-bold text-sm">
                        {route.distance} km
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex items-center justify-center gap-1 text-gray-700">
                        <Clock className="w-4 h-4 text-yellow-600" />
                        <span className="font-semibold">~{Math.round(route.distance / 50)} hrs</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <div className="flex items-center justify-end gap-1 font-bold text-black">
                        <IndianRupee className="w-4 h-4 text-yellow-600" />
                        <span>{route.fareMin.toLocaleString('en-IN')}</span>
                        <span className="text-yellow-600">-</span>
                        <span>{route.fareMax.toLocaleString('en-IN')}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Routes Cards - Mobile */}
        <div className="md:hidden space-y-4">
          {filteredRoutes.map((route, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg p-4 border-2 border-yellow-400"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="bg-yellow-400 text-black font-black px-3 py-1 rounded-full text-sm">
                  #{index + 1}
                </span>
                <span className="bg-yellow-100 text-black px-3 py-1 rounded-full font-bold text-sm">
                  {route.distance} km
                </span>
              </div>
              
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-yellow-600 flex-shrink-0" />
                  <span className="font-bold text-black text-base">{route.from}</span>
                </div>
                <ArrowRight className="w-5 h-5 text-yellow-600 flex-shrink-0 mx-2" />
                <div className="flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-yellow-600 flex-shrink-0" />
                  <span className="font-bold text-black text-base">{route.to}</span>
                </div>
              </div>

              <div className="flex items-center justify-between pt-3 border-t border-yellow-200">
                <div className="flex items-center gap-1 text-gray-700">
                  <Clock className="w-4 h-4 text-yellow-600" />
                  <span className="font-semibold text-sm">~{Math.round(route.distance / 50)} hrs</span>
                </div>
                <div className="flex items-center gap-1 font-bold text-black">
                  <IndianRupee className="w-4 h-4 text-yellow-600" />
                  <span className="text-sm">{route.fareMin.toLocaleString('en-IN')}</span>
                  <span className="text-yellow-600 text-sm">-</span>
                  <span className="text-sm">{route.fareMax.toLocaleString('en-IN')}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredRoutes.length === 0 && (
          <div className="text-center py-12">
            <p className="text-xl sm:text-2xl text-gray-600 font-semibold">No routes found matching your search</p>
          </div>
        )}

        {/* Footer */}
        <div className="mt-8 sm:mt-12 text-center">
          <div className="inline-block bg-yellow-100 rounded-xl px-4 sm:px-6 py-3 sm:py-4 border-2 border-yellow-300">
            <p className="text-xs sm:text-sm text-black font-medium">
              💡 All fares are approximate and may vary based on vehicle type, season, and availability
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CabServices;